<label class="text caption bold primary">
  @if (labelRef()) {
    <ng-container *ngTemplateOutlet="labelRef()"></ng-container>
  } @else {
    {{ label() | empty }}
  }
</label>
@let currentValue = value();
@if (isArray(currentValue)) {
  <ul>
    @for (item of currentValue; track item) {
      <li class="text medium">{{ item | empty }}</li>
    }
  </ul>
} @else {
  <div>
    <span class="text medium" [class]="valueCss()" [vitamuiTooltip]="valueTooltip()" [outline]="true" vitamuiTooltipClass="secondary">
      @if (valueUrl()) {
        <a [href]="valueUrl()">{{ currentValue | empty }}</a>
      } @else {
        {{ currentValue | empty }}
      }
    </span>
    @if (canCopyValue()) {
      <button
        (click)="copyToClipboard(currentValue)"
        class="btn btn-circle link primary xsmall d-inline-block ml-1"
        [vitamuiTooltip]="'COMMON.COPY' | translate"
        [outline]="true"
        vitamuiTooltipClass="secondary"
        tabindex="0"
      >
        <i class="vitamui-icon vitamui-icon-content-copy"></i>
      </button>
    }
  </div>
}
